import * as React from 'react';
import { Flex, FlexItem } from '../../designSystem/compositeComponents/FlexHelpers';
import { LoadingPageOverlay } from '../../designSystem/LoadingPageOverlay';
import { AmorgAdminPageProvider } from './AmorgAdminPageContext';
import { SingleColumnLayout } from '../../designSystem/layouts/SingleColumnLayout';
import { useHistory, useParams } from 'react-router-dom';
import { getActiveUser, getAllSites, getSiteUsers, updateSiteSettings } from '../../api/adminClientApi';
import { AmorgAdminToken, ApplicationFeature, ApplicationFeatures, CompanyInfo, CreceaOnlyFeatures, Partner, partners, PublicAmorgUser, Site, SiteSettings } from '../../amorg-common';
import { FormField } from '../../designSystem/formField/FormField';
import { TextInputWithSave } from '../../designSystem/inputs/TextInputWithSave';
import { Card } from '../../designSystem/Card';
import { H2, H3 } from '../../designSystem/typography/Heading';
import { Select } from '../../designSystem/inputs/Select';
import { Checkbox } from '../../designSystem/inputs/Checkbox';
import { userHelper } from '../../amorg-common/helpers/userHelper';
import { Table } from '../../designSystem/Table';
import { colors } from '../../designSystem/colors/color';
import { Icon } from '../../designSystem/icons/Icons';
import { ImpersonateModalButton } from './_components/ImpersonateModalButton';
import { AdminTab } from './_components/AdminTab';
import { txt } from '../../txt';


export function AmorgAdminSite (): JSX.Element
{
    const [loading, setLoading] = React.useState(true);
    const { siteId } = useParams<{ siteId: string; }>();
    const [site, setSite] = React.useState<Site | null>(null);
    const [users, setUsers] = React.useState<PublicAmorgUser[]>([]);
    const [activeUser, setActiveUser] = React.useState<AmorgAdminToken>(null);

    const history = useHistory();

    React.useEffect(() =>
    {
        const init = async () =>
        {
            const token = await getActiveUser(() => history.push(`/amorgy/login`));
            setActiveUser(token);

            const sites = await getAllSites(() => history.push("/amorgy/login"));
            const site = sites.find((s) => s.id === siteId);
            setSite(site);
            if (!site)
            {
                throw new Error("Invalid siteId");
            }

            const users = await getSiteUsers(site.id, () => history.push("/amorgy/login"));
            setUsers(users);
            console.log(users);

            setLoading(false);
        };
        init().catch(console.error);
    }, []);


    async function handleUpdateSiteSettings (settings: SiteSettings, companyInfo: CompanyInfo, partner: Partner | null, loginName:string)
    {
        setLoading(true);
        await updateSiteSettings(siteId, settings, companyInfo, partner, loginName, () => history.push('/amorgy/login'));
        // setSites(await getSites());
        const sites = await getAllSites(() => history.push("/amorgy/login"));
        const site = sites.find((s) => s.id === siteId);
        setSite(site);
        setLoading(false);
    }


    return (
        <>
            {site &&
                
                <AmorgAdminPageProvider>
                    <LoadingPageOverlay loading={loading} />
                    <SingleColumnLayout
                        noDivider
                        headerContainer={
                            <Flex flexDirection="column" gap={16}>
                                <AdminTab selectedTab='sites' />
                            </Flex>
                        }

                        contentContainer={
                            <Flex flexDirection='column' gap={32}>

                                <CompanyInfo activeUser={activeUser} site={site} onUpdateSiteSettings={handleUpdateSiteSettings} />

                                <Users users={users} />
                            </Flex>
                        } />
                </AmorgAdminPageProvider>
                
            }   </>
    );
}

type CompanyInfoProps = {
    activeUser:AmorgAdminToken;
    site: Site,
    onUpdateSiteSettings: (settings: SiteSettings, companyInfo: CompanyInfo, partner: Partner | null, loginName:string) => Promise<void>;
};
function CompanyInfo ({ activeUser, site, onUpdateSiteSettings }: CompanyInfoProps): JSX.Element
{
    function handleChangeName ()
    {
        return (value: string) => onUpdateSiteSettings(site.settings, { ...site.companyInfo, name: value }, site.partner, site.loginName);
    }

    function handleChangeAddress ()
    {
        return (value: string) => onUpdateSiteSettings(site.settings, { ...site.companyInfo, address: value }, site.partner, site.loginName);
    }

    function handleChangeAltAddress ()
    {
        return (value: string) => onUpdateSiteSettings(site.settings, { ...site.companyInfo, altAddress: value }, site.partner, site.loginName);
    }

    function handleChangeZip ()
    {
        return (value: string) => onUpdateSiteSettings(site.settings, { ...site.companyInfo, zip: value }, site.partner, site.loginName);
    }

    function handleChangeCity ()
    {
        return (value: string) => onUpdateSiteSettings(site.settings, { ...site.companyInfo, city: value }, site.partner, site.loginName);
    }
    function handleChangePhone ()
    {
        return (value: string) => onUpdateSiteSettings(site.settings, { ...site.companyInfo, phone: value }, site.partner, site.loginName);
    }
    function handleChangeWebsite ()
    {
        return (value: string) => onUpdateSiteSettings(site.settings, { ...site.companyInfo, website: value }, site.partner, site.loginName);
    }
    function handleChangeNote ()
    {
        return (value: string) => onUpdateSiteSettings(site.settings, { ...site.companyInfo, note: value }, site.partner, site.loginName);
    }

    function handleChangeApiVideoKey ()
    {
        return (value: string) => onUpdateSiteSettings({ ...site.settings, apiVideoKey: value }, site.companyInfo, site.partner, site.loginName);
    }

    const isCreceaOrAdmin = activeUser.superAdmin || site.partner === 'Crecea';

    return (
        <Flex flexDirection="column" gap={32}>
            <Flex flexDirection='column' gap={4}>
                <Flex justifyContent="space-between" alignItems="center" gap={16}>
                    <H2>Stamdata</H2>
                    <ImpersonateModalButton
                        siteId={site.id}
                        siteEnabled={site.settings.enabled} />
                </Flex>
                <Card variant="outlined">
                    
                    <Flex flexDirection="column" gap={16}>
                        <FormField
                            label='Navn'
                            inputComponent={
                                <TextInputWithSave
                                    type={'text'}
                                    value={site.companyInfo.name}
                                    onSave={handleChangeName()}
                                />
                            }
                        />

                        <Flex flexDirection="row" gap={16}>
                            <FlexItem flexGrow="1">
                                <FormField
                                    label='Adresse'
                                    inputComponent={
                                        <TextInputWithSave
                                            type={'text'}
                                            value={site.companyInfo.address}
                                            onSave={handleChangeAddress()}
                                        />
                                    }
                                />
                            </FlexItem>
                            <FlexItem flexGrow="1">
                                <FormField
                                    label='C/O adresse'
                                    inputComponent={
                                        <TextInputWithSave
                                            type={'text'}
                                            value={site.companyInfo.altAddress}
                                            onSave={handleChangeAltAddress()}
                                        />
                                    }
                                />
                            </FlexItem>
                        </Flex>
                        <Flex flexDirection="row" gap={16}>
                            <FlexItem flexGrow="1">
                                <FormField
                                    label='Postnummer'
                                    inputComponent={
                                        <TextInputWithSave
                                            type={'text'}
                                            value={site.companyInfo.zip}
                                            onSave={handleChangeZip()}
                                        />
                                    }
                                />
                            </FlexItem>
                            <FlexItem flexGrow="1">
                                <FormField
                                    label='By'
                                    inputComponent={
                                        <TextInputWithSave
                                            type={'text'}
                                            value={site.companyInfo.city}
                                            onSave={handleChangeCity()}
                                        />
                                    }
                                />
                            </FlexItem>
                        </Flex>

                        <Flex flexDirection="row" gap={16}>
                            <FlexItem flexGrow="1">
                                <FormField
                                    label='Telefon'
                                    inputComponent={
                                        <TextInputWithSave
                                            type={'text'}
                                            value={site.companyInfo.phone}
                                            onSave={handleChangePhone()}
                                        />
                                    }
                                />
                            </FlexItem>
                            <FlexItem flexGrow="1">
                                <FormField
                                    label='Website'
                                    inputComponent={
                                        <TextInputWithSave
                                            type={'text'}
                                            value={site.companyInfo.website}
                                            onSave={handleChangeWebsite()}
                                        />
                                    }
                                />
                            </FlexItem>
                        </Flex>

                        <FormField
                            label='Note'
                            inputComponent={
                                <TextInputWithSave
                                    type={'text'}
                                    value={site.companyInfo.note}
                                    onSave={handleChangeNote()}
                                />
                            }
                        />

                    </Flex>
                </Card>
            </Flex>
            <Flex flexDirection='column' gap={4}>
                <H2>Indstillinger</H2>
                <Card variant="outlined">
                    <Flex flexDirection="column" gap={16}>

                        <FormField
                            label="Navn ved login"
                            toolTip="Navnet brugere skal anvende ved login"
                            inputComponent={
                                <TextInputWithSave
                                    type={'text'}
                                    value={site.loginName}
                                    onSave={(value) => onUpdateSiteSettings(site.settings, site.companyInfo, site.partner, value)}
                                />
                            }
                        />

                        <FormField
                            label='Video API key'
                            inputComponent={
                                <TextInputWithSave
                                    type={'text'}
                                    value={site.settings.apiVideoKey}
                                    onSave={handleChangeApiVideoKey()}
                                />
                            }
                        />

                        <FormField
                            label='Partner'
                            inputComponent={
                                <Select
                                    options={[
                                        { text: 'Ingen partner', value: '' },
                                        ...partners.map(p => ({ text: p, value: p }))
                                    ]}
                                    selectedValue={site.partner || ''}
                                    onChange={(value) => onUpdateSiteSettings({ ...site.settings }, site.companyInfo, value === '' ? null : value as Partner, site.loginName)}
                                />
                            }
                        />

                        <Flex justifyContent='space-around'>
                                    
                            <Flex flexDirection='column'>
                                <H3>Basefunktionalitet</H3>
                                {ApplicationFeatures.filter(f => !CreceaOnlyFeatures.includes(f)).map(f =>
                                    <Checkbox
                                        key={f}
                                        text={txt.featureText(f)}
                                        value={f}
                                        checked={site.settings.features.includes(f)}
                                        onChange={(name, checked) =>
                                        {
                                            const features: ApplicationFeature[] = checked
                                                ? [...site.settings.features, name as ApplicationFeature]
                                                : site.settings.features.filter(f => f !== name);
                                            onUpdateSiteSettings({ ...site.settings, features }, site.companyInfo, site.partner, site.loginName);
                                        }} />
                                )}
                            </Flex>

                            {isCreceaOrAdmin &&
                                <Flex flexDirection='column'>
                                    <H3>Crecea funktionalitet</H3>
                                    {CreceaOnlyFeatures.map(f =>
                                        <Checkbox
                                            key={f}
                                            text={txt.featureText(f)}
                                            value={f}
                                            checked={site.settings.features.includes(f)}
                                            onChange={(name, checked) =>
                                            {
                                                const features: ApplicationFeature[] = checked
                                                    ? [...site.settings.features, name as ApplicationFeature]
                                                    : site.settings.features.filter(f => f !== name);
                                                onUpdateSiteSettings({ ...site.settings, features }, site.companyInfo, site.partner, site.loginName);
                                            }} />
                                    )}
                                </Flex>
                            }

                            <Flex flexDirection='column'>
                                <H3>Valgindstillinger</H3>
                                <Checkbox
                                    id="hideSurveyEmailAddresses"
                                    text='Skjul email i spørgeskemabesvarelser'
                                    value='hideSurveyEmailAddresses'
                                    checked={site.settings.hideSurveyEmailAddresses}
                                    onChange={(name, checked) =>
                                    {
                                        onUpdateSiteSettings({ ...site.settings, hideSurveyEmailAddresses: checked }, site.companyInfo, site.partner, site.loginName);
                                    }} />
                            </Flex>

                        </Flex>
                    </Flex>
                </Card>
            </Flex>
        </Flex>
    );
}

type UsersProps = {
    users: PublicAmorgUser[];
};
function Users (props: UsersProps): JSX.Element
{
    const articleContactCount = props.users.filter(u => u.settings.articleContact).length;

    return (
        <>
            <Table>
                <thead>
                    <tr>
                        <th>Navn</th>
                        <th>Email</th>
                        <th style={{ textAlign: 'center' }}>Lovservice kontakt ({articleContactCount}) </th>
                    </tr>
                </thead>
                <tbody>
                    {props.users.map(u =>
                        <tr key={u.id}>
                            <td>
                                {userHelper.getPublicUserFullName(u)}
                            </td>
                            <td>
                                {u.email}
                            </td>
                            <td style={{ textAlign: 'center' }}>

                                {u.settings.articleContact &&
                                    <Flex justifyContent="center" alignItems="center" gap={4}>
                                        <Icon name="status_ok" color={colors.icon.success} />
                                    </Flex>
                                }

                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>

            {props.users.length === 0 &&
                <span>Ingen brugere oprettet</span>
            }
        </>
    );
}